module.exports = __webpack_public_path__ + "img/未入会预览图@2x.0993c908.png";